import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  add_feedback,
  delete_feedback,
  get_feedback,
  update_feedback,
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  feedbacks: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    students: "",
    feedback_text: "",
    school_class: "",
    section: "",
  },
  filterData: {
    student_id: "",
    class_id: "",
    section_id: "",
  },
};

// Async Thunks for API Calls
export const fetchfeedback = createAsyncThunk(
  "feedback/fetchfeedback",
  async (
    { page, page_size, school_id, class_id, student_id, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_feedback(
        page,
        page_size,
        school_id,
        class_id,
        student_id,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createfeedback = createAsyncThunk(
  "feedback/createfeedback",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_feedback(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatefeedback = createAsyncThunk(
  "feedback/updatefeedback",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_feedback(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletefeedback = createAsyncThunk(
  "feedback/deletefeedback",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_feedback({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const feedbackSlice = createSlice({
  name: "feedbacks",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    updateFilterData(state, action) {
      const { name, value } = action.payload;
      state.filterData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, subject, file, school_class } = action.payload;
      state.formData = { id, subject, file, school_class };
    },
    resetFormData(state) {
      state.formData = {
        students: "",
        feedback_text: "",
        school_class: "",
        section: "",
      };
    },
    resetFilterData(state) {
      state.filterData = {
        student_id: "",
        class_id: "",
        section_id: "",
      };
    },
    setfeedback(state, action) {
      state.feedback = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
   
  },
  extraReducers: (builder) => {
    builder

      // Fetch Classes
      .addCase(fetchfeedback.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchfeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.feedbacks = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchfeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createfeedback.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createfeedback.fulfilled, (state, action) => {
        state.addLoading = false;
        state.feedbacks = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createfeedback.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatefeedback.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatefeedback.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatefeedback.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;
        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletefeedback.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletefeedback.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletefeedback.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setfeedback,
  setActivePage,
  updateFormData,
  updateFilterData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
  resetFilterData
} = feedbackSlice.actions;
export default feedbackSlice.reducer;
